import {type GuidedV2LinkAttribute} from '../../models/quick-link';
import {type labelProviderInterface} from '../../../LabelProviderInterface';
import {h} from '@stencil/core';
import {getImportance} from '../../utils';

export const GuidedV2LinkAttributeRender = (props: {
  attribute: GuidedV2LinkAttribute,
  labelProvider?: labelProviderInterface
})=>{
    const {attribute} = props;
    const importance = getImportance(attribute?.importance);

    // qds-tag doesn't allow markup within elements
    // const val = attribute.attributeValue;
    const val = attribute.attributeValueMarkup ?? attribute.attributeValue;

    let displayAttribute = [val];

    if(attribute.attributeName) {
      let attributeLabel = attribute.attributeName;
      if (props.labelProvider) {
        attributeLabel = props.labelProvider('guided-v2.quick-link.attributes.' + attribute.attributeName, attribute.attributeName);
      }
      displayAttribute = [`${attributeLabel}: `, val];
    }


    if(!val){
      return <span class={'invalid-attribute'} data-value={JSON.stringify(attribute)}></span>;
    }

    return (
      <span class={`guided-v2-result-list-section__result-extra-info guided-v2-result-list-attribute guided-v2-importance__${importance}`}>
        {displayAttribute}
      </span>
    );
};
